import { Injectable } from '@angular/core';
import { Navigation, TargetType } from '../dto/response/template.config';
import { Params, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(private router: Router) {}

  navigateTo(navigation?: Navigation) {
    if (navigation) {
      let url: string | undefined;
      switch (navigation.target) {
        case TargetType.PLP:
          url =
            '/products' +
            navigation.filter?.endpoint?.replaceAll(
              'store/client/products',
              '',
            );
          break;
        case TargetType.PDP:
          url =
            '/product' +
            navigation.filter?.endpoint?.replaceAll('store/client/product', ''); // Ruta para PDP
          console.log('navigateTo Product', url);
          break;
        case TargetType.EXTERNAL_PAGE:
          window.open(navigation.path, '_blank');
          break;
        case TargetType.INTERNAL_PAGE:
          url = '/' + navigation.path; // Ruta para PDP
          break;
        default:
          throw new Error(`Unsupported target type: ${navigation.target}`);
      }
      if (url) {
        this.router.navigateByUrl(url);
      }
    }
  }

  extractQueryParamsFromUri(uri: string): Params {
    const queryString = uri.split('?')[1];
    const params: Params = {};
    if (queryString) {
      const searchParams = new URLSearchParams(queryString);

      searchParams.forEach((value, key) => {
        const values = searchParams.getAll(key);
        params[key] = values.length > 1 ? values : values[0];
      });
    }
    return params;
  }
}
